import { Component, Inject } from '@angular/core';
import { SelectMaterialFromStoreComponent } from "../select-material-from-store/select-material-from-store.component";
import { SimpleHeaderComponent } from '@ildes/basic/simple-header/simple-header.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common'
import { DropdownSelectorComponent } from '@ildes/basic/dropdown-selector/dropdown-selector.component';
import { ALLEGED_CAUSE_OF_FAIL, TECHNOLOGIES, ADD_MATERIAL_ACTIVITY } from '@ildes/config/constants';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ApiManagerService } from '@ildes/services/api-manager.service';
import { map } from 'rxjs/operators';
import { PredictiveSearcherComponent } from '@ildes/basic/predictive-searcher/predictive-searcher.component';
import { ToastService } from '@ildes/services/toast.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { InputDialogComponent } from '@ildes/basic/input-dialog/input-dialog.component';
import { AlertDialogComponent } from '@ildes/basic/alert-dialog/alert-dialog.component';


@Component({
  
  standalone: true,
  imports: [
    CommonModule,
    SelectMaterialFromStoreComponent,
    SimpleHeaderComponent,
    MatButtonModule,
    DropdownSelectorComponent,
    MatDividerModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    PredictiveSearcherComponent,
    MatProgressBarModule,
    AlertDialogComponent
  ],
  template: `
    <simple-header title="Modificar Datos de reparación" (action)="close()" icon="close"></simple-header>
    <h3>Cambiar fecha de reparación</h3>
    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Fecha de cierre</mat-label>
        <input matInput [formControl]="newRepairmentDate" [matDatepicker]="picker">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <h3>Cambiar datos de luminaria</h3>
    <h4>
        Punto afectado
    <h4>
    <predictive-searcher
        class="column margin-top-8"
        [formControl]="luminary"
        label="Número de luminaria"
        [service]="searchLuminaryAdapter"></predictive-searcher>
    <h4>Datos de luminaria retirada</h4>
    <div class="margin-top-16">
        <mat-form-field appearance="outline" class="full-width">
        <mat-label>Número de luminaria</mat-label>
        <input matInput [formControl]="oldLuminaryNumberForm">
        </mat-form-field>
    </div>
    <div class="inline-flex">
        <div class="inline-flex column">
        <dropdown-selector
            class="column margin-right-8"
            [(selected)]="oldTechnology"
            label="Tecnología"
            [types]="technologies"
            (selectedChange)="this.oldTechnology = $event"></dropdown-selector>
        <mat-form-field appearance="outline" class="column margin-right-column-8">
            <mat-label>Potencia</mat-label>
            <input [formControl]="oldPower" matInput maxlength="20">
        </mat-form-field>
        </div>
    </div>
    <h4>Datos de luminaria instalada</h4>
    <div class="margin-top-8">
        <mat-form-field appearance="outline" class="full-width">
        <mat-label>Número de luminaria</mat-label>
        <input matInput [formControl]="newLuminaryNumberForm">
        </mat-form-field>
    </div>
    <div class="inline-flex">
        <div class="inline-flex column">
        <dropdown-selector
            class="column margin-right-8"
            [(selected)]="newTechnology"
            label="Tecnología"
            [types]="technologies"
            (selectedChange)="this.newTechnology = $event"></dropdown-selector>
        <mat-form-field appearance="outline" class="column margin-right-column-8">
            <mat-label>Potencia</mat-label>
            <input [formControl]="newPower" matInput maxlength="20">
        </mat-form-field>
        </div>
    </div>
    <mat-divider></mat-divider>
    <div class="padding-top-8 padding-bottom-8">
        <mat-checkbox [(ngModel)]="luminaryOfTemporalUse" [ngModelOptions]="{standalone: true}">Luminaria de uso temporal</mat-checkbox>
    </div>
    <div class="padding-top-8 padding-bottom-8">
        <app-alert-dialog text="Los cambios no se propagarán a la luminaria. Si lo necesita, puede corregirlos a mano buscando y editando la luminaria." status="advise"></app-alert-dialog>
    </div>
    <!-- <h3>Cambiar material usado</h3>
    <app-select-material-from-store (materialsChanged)="onMaterialsChanged($event)"></app-select-material-from-store> -->
    <mat-divider></mat-divider>
    <h3 class="padding-top-8">Cambiar presunta causa de falla</h3>
    <dropdown-selector [noEmptyValue]="false" class="column" [(selected)]="allegedCauseOfFail" label="Presunta causa de  falla" [types]="allegedCausesOfFailList" (selectedChange)="selectAllegedCauseOfFail($event)" ></dropdown-selector>
    <mat-divider></mat-divider>
    <mat-progress-bar mode="indeterminate" *ngIf="loadingChanges"></mat-progress-bar>
    <div>
        <div class="align-center">
        <button [disabled]="!hasChanges || loadingChanges" mat-button class="button-size-200" (click)="confirmSelectedMaterials()">Confirmar</button>
        </div>
    </div>
  `,
  styleUrls: ['./select-material-from-store-dialog.component.css'],
})
export class SelectMaterialFromStoreDialogComponent {

    selectedMaterials = null;
    allegedCausesOfFailList = ALLEGED_CAUSE_OF_FAIL;
    allegedCauseOfFail = null;
    newRepairmentDate;
    luminaryOfTemporalUse = false;
    newLuminaryNumberForm = new FormControl();
    oldTechnology = null;
    newTechnology = null;
    oldPower = null;
    newPower = null;
    technologies = TECHNOLOGIES;
    oldLuminaryNumberForm = new FormControl();
    maintenance;
    searchLuminaryAdapter
    luminary;
    loadingChanges;
    constructor(
        private dialogRef: MatDialogRef<SelectMaterialFromStoreDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data,
        private apiManager: ApiManagerService,
        private toast: ToastService,
        private dialog: MatDialog,
    ) {
        this.searchLuminaryAdapter = (data) => {
            return this.apiManager.listLuminaries({ number: data.text }).pipe(
                map(({ data }: any) => ( {data: this.normalize(data)}))
            )
        };
        this.maintenance = data.maintenance;
        this.newRepairmentDate = new FormControl(this.maintenance.repairmentDate);
        this.oldLuminaryNumberForm = new FormControl(this.maintenance.oldLuminaryNumber ||'');
        this.newLuminaryNumberForm = new FormControl(this.maintenance.newLuminaryNumber || '');
        this.newPower = new FormControl(this.maintenance.newPower || null);
        this.oldPower = new FormControl(this.maintenance.oldPower || null);
        this.newTechnology = this.maintenance.newTechnology;
        this.oldTechnology = this.maintenance.oldTechnology || null;
        this.allegedCauseOfFail = ALLEGED_CAUSE_OF_FAIL.find(( {id} ) => id === this.maintenance.allegedCauseOfFail?.id)
        this.luminaryOfTemporalUse = this.maintenance.luminaryOfTemporalUse;
        this.luminary = new FormControl({
            selected: this.maintenance.luminary,
            typed: this.maintenance.luminary.number
        })
    }
    onMaterialsChanged(event) {
        this.selectedMaterials = event;
    }

    confirmSelectedMaterials() {
        const dialog = this.dialog.open(InputDialogComponent, {
            data: {
                title: 'Motivo del cambio',
                inputLabel: 'Observaciones'
            }
        });
    
        dialog.afterClosed().subscribe((data) => {
            if (!data?.text) {
                return;
            }
    
            this.save(data.text)
        });
    }

    save(observations) {
        const data = {
            observations,
            ...this.luminary.value?.selected && this.luminary.value?.selected.id !== this.maintenance.luminary.id && { luminary: this.luminary.value?.selected.id },
            ...this.oldLuminaryNumberForm.value && this.oldLuminaryNumberForm.value !== this.maintenance.oldLuminaryNumber && { oldLuminaryNumber: this.oldLuminaryNumberForm.value}, 
            ...this.newLuminaryNumberForm.value && this.newLuminaryNumberForm.value !== this.maintenance.newLuminaryNumber && { newLuminaryNumber: this.newLuminaryNumberForm.value}, 
            ...this.oldTechnology && this.oldTechnology !== this.maintenance.oldTechnology && { oldTechnology: this.oldTechnology },
            ...this.newTechnology && this.newTechnology !== this.maintenance.newTechnology && { newTechnology: this.newTechnology}, 
            ...this.newPower.value && parseInt(this.newPower.value) !== parseInt(this.maintenance.newPower) && { newPower: this.newPower.value}, 
            ...this.oldPower.value && parseInt(this.oldPower.value) !== parseInt(this.maintenance.oldPower) && { oldPower: this.oldPower.value}, 
            ...this.luminaryOfTemporalUse !== undefined &&  this.luminaryOfTemporalUse !== this.maintenance.luminaryOfTemporalUse && { luminaryOfTemporalUse: this.luminaryOfTemporalUse},
            ...this.selectedMaterials?.length > 0 && this.validSelectedMaterials && { selectedMaterials: this.selectedMaterials, activities: this.getActivities()},
            ...this.allegedCauseOfFail && this.allegedCauseOfFail.id !== this.maintenance.allegedCauseOfFail?.id && { allegedCauseOfFail: this.allegedCauseOfFail},
            ...this.newRepairmentDate.value && this.newRepairmentDate.value !== this.maintenance.repairmentDate && { repairmentDate: this.newRepairmentDate.value },
        };

        this.loadingChanges = true;
        this.apiManager.updateRepairmentData(this.maintenance.id, data).subscribe(() => {
            this.loadingChanges = false;
            this.toast.show('Cambios realizados correctamente', 'ok');
            this.dialogRef.close( { refresh: true })
        }, () => {
            this.loadingChanges = false;
        });
    }

    close() {
        this.dialogRef.close( { closed: true })
    }

    get validSelectedMaterials() {
        if (!this.selectedMaterials?.length) {
            return this.allegedCauseOfFail?.description;
        }
        for(let i = 0; i< this.selectedMaterials.length; i++) {
            if (this.selectedMaterials[i].amount > this.selectedMaterials[i].max) {
                return this.allegedCauseOfFail?.description;
            }
        }

        return this.selectedMaterials.length > 0 || this.allegedCauseOfFail?.description;
    }

    selectAllegedCauseOfFail(event) {
        this.allegedCauseOfFail = event;
    }

    normalize(data) {
        return data.map((object) => ({...object, ...{ name: object.number }}));
    }

    get hasChanges() {
        return this.luminary.value?.selected && this.luminary.value?.selected.id !== this.maintenance.luminary.id || 
            this.oldLuminaryNumberForm.value && this.oldLuminaryNumberForm.value !== this.maintenance.oldLuminaryNumber || 
            this.newLuminaryNumberForm.value && this.newLuminaryNumberForm.value !== this.maintenance.newLuminaryNumber || 
            this.oldTechnology && this.oldTechnology !== this.maintenance.oldTechnology || 
            this.newTechnology && this.newTechnology !== this.maintenance.newTechnology || 
            this.newPower.value && parseInt(this.newPower.value) !== parseInt(this.maintenance.newPower) || 
            this.oldPower.value && parseInt(this.oldPower.value) !== parseInt(this.maintenance.oldPower) || 
            this.luminaryOfTemporalUse !== undefined &&  this.luminaryOfTemporalUse !== this.maintenance.luminaryOfTemporalUse ||
            this.selectedMaterials?.length > 0 && this.validSelectedMaterials ||
            this.allegedCauseOfFail && this.allegedCauseOfFail.id !== this.maintenance.allegedCauseOfFail?.id ||
            this.newRepairmentDate.value && this.newRepairmentDate.value !== this.maintenance.repairmentDate
            
    }

    getActivities() {
        const activitiesFromUsedMaterials = this.selectedMaterials.map((data: any) => {
            return Array.from(Array(data.amount)).map(() => ( {...ADD_MATERIAL_ACTIVITY, extraData: data.reference.name }));
        }).flat();
    
        return [...this.maintenance.activities || [], ...activitiesFromUsedMaterials];
    }
}
